module.exports = __webpack_public_path__ + "img/Belarus.9df8cf98.png";